import type { CSSProperties } from 'react';

/**
 * Shared premium-spectrum accent for public identity surfaces.
 * The repeated blue endpoint keeps circular rings and long borders visually seamless.
 */
export const RAINBOW_GRADIENT =
  'linear-gradient(115deg, #2563EB 0%, #14B8A6 20%, #22C55E 34%, #FACC15 51%, #EF4444 69%, #8B5CF6 86%, #2563EB 100%)';

/** Layer a solid/gradient surface over the shared spectrum to create a stable 1px frame. */
export function rainbowBorderBackground(surface: string): string {
  return `${surface} padding-box, ${RAINBOW_GRADIENT} border-box`;
}

export function rainbowFrameClassName(padding = 'p-[2px]') {
  return `${padding} rounded-xl shadow-[0_12px_32px_rgba(99,102,241,0.12)]`;
}

export function rainbowFrameStyle(): CSSProperties {
  return { background: RAINBOW_GRADIENT };
}

export const SOFT_RAINBOW_GRADIENT =
  'linear-gradient(115deg,rgba(45,212,191,0.75),rgba(132,204,22,0.55),rgba(250,204,21,0.55),rgba(244,114,182,0.55),rgba(139,92,246,0.65),rgba(56,189,248,0.65))';

export function softRainbowBorderBackground(surface: string): string {
  return `${surface} padding-box, ${SOFT_RAINBOW_GRADIENT} border-box`;
}
